import { Action as _Action } from '@ngrx/store';
import { AuthStrategy, OktaUserclaim } from './auth.interfaces';

export const LOGIN: string = '[Auth] LOGIN';
export const SET_AD_USER: string = '[Auth] SET AD USER';
export const LOGIN_SUCCESS: string = '[Auth] LOGIN SUCCESS';
export const LOGIN_FAILED: string = '[Auth] LOGIN FAILED';
export const LOGOUT: string = '[Auth] LOGOUT';
export const LOGOUT_SUCCESS: string = '[Auth] LOGOUT SUCCESS';
export const EXTEND_LOGOUT_TIMER: string = '[Auth] EXTEND LOGOUT TIMER';
export const SHOW_LOGOUT_TIMER_DIALOG: string = '[Auth] SHOW LOGOUT TIMER DIALOG';
export const SESSION_UPDATED: string = '[Auth] SESSION UPDATED';
export const SET_USER_TYPE: string = '[Auth] SET USER TYPE';
export const SET_AUTH_TYPE: string = '[Auth] SET AUTH TYPE';
export const SET_IS_AUTHENTICATED: string = '[Auth] SET IS AUTHENTICATED';
export const SET_AUTHENTICATION_STARTED: string = '[Auth] SET AUTHENTICATION STARTED';
export const SET_AUTHENTICATION_ENDED: string = '[Auth] SET AUTHENTICATION ENDED';
export const SET_OKTA_USERCLAIM: string = '[Auth] SET OKTA USERCLAIM';

export class Login implements _Action {
  readonly type = LOGIN;
  constructor(public payload = null) {}
}
export class SetAdUser implements _Action {
  readonly type = SET_AD_USER;
  constructor(public payload = null) {}
}
export class LoginSuccess implements _Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: adal.User) {}
}

export class LoginFailed implements _Action {
  readonly type = LOGIN_FAILED;
  constructor(public payload = null) {}
}

export class Logout implements _Action {
  readonly type = LOGOUT;
  constructor(public payload?: AuthStrategy) {}
}
export class LogoutSuccess implements _Action {
  readonly type = LOGOUT_SUCCESS;
  constructor(public payload = null) {}
}

export class ExtendLogoutTimer implements _Action {
  readonly type = EXTEND_LOGOUT_TIMER;
}

export class SessionUpdated implements _Action {
  readonly type = SESSION_UPDATED;
}

export class ShowLogoutTimerDialog implements _Action {
  readonly type = SHOW_LOGOUT_TIMER_DIALOG;
}

export class SetUserType implements _Action {
  readonly type = SET_USER_TYPE;  
  constructor(public payload: string) {}
}

export class SetAuthenticationStrategy implements _Action {
  readonly type = SET_AUTH_TYPE;  
  constructor(public payload: AuthStrategy) {}
}

export class SetIsAuthenticated implements _Action {
  readonly type = SET_IS_AUTHENTICATED;
  constructor(public payload: boolean) {}
}

export class SetAuthenticationStarted implements _Action {
  readonly type = SET_AUTHENTICATION_STARTED;
  constructor(public payload: boolean) {}
}

export class SetAuthenticationEnded implements _Action {
  readonly type = SET_AUTHENTICATION_ENDED;
  constructor(public payload: boolean) {}
}

export class SetOktaUserclaim implements _Action {
  readonly type = SET_OKTA_USERCLAIM;
  constructor(public payload: OktaUserclaim) {}
}

export type Action =
  | Login
  | LoginSuccess
  | LoginFailed
  | Logout
  | LogoutSuccess
  | ExtendLogoutTimer
  | ShowLogoutTimerDialog
  | SessionUpdated
  | SetAdUser
  | SetUserType
  | SetAuthenticationStrategy
  | SetIsAuthenticated
  | SetAuthenticationStarted
  | SetAuthenticationEnded;
